import { useSportMenuItemGetter } from '@/hooks/query';
import { useLocale } from 'next-intl';
import { useRouter } from '@/navigation';
import { useCallback } from 'react';


export const useGoToWcPromotionMenuUrl = () => {
	const { getSportMenuItemsOfMode } = useSportMenuItemGetter();
	const locale = useLocale();
	const router = useRouter();

	const goToWcPromotionMenuUrl = useCallback(() => {
		let worldCupHref = getSportMenuItemsOfMode('M2').find(item => item.gameId === '1')?.href;
		if (!worldCupHref?.includes('/world/world-cup/1')) {
			worldCupHref = '/world/world-cup/1/e';
		}
		router.push(worldCupHref, { locale });
	}, [getSportMenuItemsOfMode, locale, router]);

	return goToWcPromotionMenuUrl;
};
